import React from "react";
import PropTypes from "prop-types";

/**
 * ProductTitle Atom - Displays product title with consistent styling
 * @component
 * @example
 * <ProductTitle title="Amazing Product" onClick={() => console.log('clicked')} />
 */
const ProductTitle = ({
    title,
    onClick,
    className = "",
    isSpecial = false,
}) => {
    return (
        <div className={`mt-2.5 text-center ${isSpecial ? "text-white" : "text-neutral-green-500"} mb-3 ${className}`}>
            <h2
                onClick={onClick}
                className={onClick ? "cursor-pointer" : ""}
            >
                {title}
            </h2>
        </div>
    );
};

ProductTitle.propTypes = {
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    className: PropTypes.string,
    isSpecial: PropTypes.bool,
};

export default ProductTitle;
